import { useState, useEffect } from "react";

export default function useResponsiveFlags() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(
    window.innerWidth >= 768 && window.innerWidth < 1024
  );
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const [isTabletLogin, setIsTabletLogin] = useState(
    window.innerWidth >= 768 && window.innerWidth < 1324
  );
  const [isDesktopLogin, setIsDesktopLogin] = useState(
    window.innerWidth >= 1324
  );
  const [isSmallMobileScreen, setIsSmallMobileScreen] = useState(
    window.innerWidth < 576
  );
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsSmallMobileScreen(width < 576);
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
      setIsDesktop(width >= 1024);
      setIsTabletLogin(width >= 768 && width < 1324);
      setIsDesktopLogin(width >= 1324);
    };

    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    isMobile,
    isTablet,
    isDesktop,
    isDesktopLogin,
    isTabletLogin,
    isSmallMobileScreen,
  };
}
